var React = require('react');

function PlaylistManager (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22 17.5L18.5 20V15L22 17.5Z","fill":"currentColor","stroke":"white","strokeWidth":"1.54","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2 5H20M2 11H20M2 17H14","stroke":"currentColor","strokeWidth":"1.54","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PlaylistManager.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PlaylistManager;

PlaylistManager.default = PlaylistManager;
